import { Avatar } from "antd";
import { useSelector } from "react-redux";
import "./TeamSelectionMenu.css";
import { CheckOutlined } from "@ant-design/icons";
import { getTeamInformation } from "../../store/actions/team.actions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import axios from "axios";
import { selectManagerTeam } from "../../store/actions/manager.actions";

export const TeamSelectionMenu = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { teams } = useSelector(({ manager }) => manager);
  const teamId = localStorage.getItem("team-id");

  const handleSelectTeam = async (team) => {
    const valid = await dispatch(selectManagerTeam(team.id));
    if (valid) {
      navigate("/overview");
    }
  };

  return (
    <div style={{ marginBottom: 16 }}>
      {teams.map((team) => (
        <div
          className="nav-team-selection-item"
          style={{ backgroundColor: team.id == teamId ? "#cccccc" : "white" }}
          key={team.id}
          onClick={() => handleSelectTeam(team)}
        >
          <Avatar src={team.team_logo} />
          <strong style={{ flex: 1 }}>{team.display_name}</strong>
          <div style={{ width: 32, textAlign: "right" }}>
            {team.id == teamId && (
              <CheckOutlined style={{ color: "#31B452" }} />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
